import apiClient from 'api/client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const PROCESSED_STAGE_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TRACEABILITY,
  VERSIONS.V1,
  RESOURCES.PROCESSED_STAGE,
  false
);

export const processedStageApi = {
  processedStageForm: () => apiClient.get(`${PROCESSED_STAGE_BASE}/form`),

  editProcessedStageForm: Id =>
    apiClient.get(
      `${PROCESSED_STAGE_BASE}/form?is_edit=true&process_stage_id=${Id}`
    ),

  createProcessedStage: combinedData =>
    apiClient.post(`${PROCESSED_STAGE_BASE}`, combinedData),

  updateProcessedStage: (processed_id, combinedData) =>
    apiClient.put(`${PROCESSED_STAGE_BASE}/${processed_id}`, combinedData),

  updateProcessedStageStatus: (processed_id, isActive) =>
    apiClient.post(
      `${PROCESSED_STAGE_BASE}/status?id=${processed_id}&isActive=${isActive}`
    )
};
